import Reveal from "../components/Reveal";
import { CATEGORIES, openPreferences } from "../lib/consent";

export default function Cookies() {
  return (
    <section className="container-prose pt-16 sm:pt-24 pb-24">
      <Reveal>
        <span className="pill pill-lav">Cookie policy</span>
        <h1 className="mt-5 font-display text-5xl sm:text-6xl leading-[1.02] text-balance">
          How Sanctology uses <em className="not-italic grad-text">cookies.</em>
        </h1>
        <p className="mt-6 text-lg text-ink-500 leading-relaxed">
          We default to denying all non-essential cookies. The only things
          that run on your first visit are strictly necessary for the site
          to function. We never set pre-ticked boxes, and we keep an
          auditable record of every consent decision.
        </p>
      </Reveal>

      <Reveal delay={80}>
        <div className="surface mt-10 space-y-6">
          <h2 className="font-display text-2xl">Categories</h2>
          {CATEGORIES.map((cat) => (
            <div key={cat.id} className="border-t border-ink-200/50 pt-5">
              <div className="flex items-center gap-2">
                <span className="font-semibold text-ink-900">{cat.label}</span>
                {cat.required && (
                  <span className="font-mono text-[10px] uppercase tracking-widest rounded-full bg-ink-100 px-2 py-0.5 text-ink-500 border border-ink-200/50">
                    Always on
                  </span>
                )}
              </div>
              <p className="mt-2 text-sm text-ink-500 leading-relaxed">
                {cat.description}
              </p>
            </div>
          ))}
        </div>
      </Reveal>

      <Reveal delay={140}>
        <div className="mt-8 flex flex-wrap gap-3">
          <button
            type="button"
            onClick={openPreferences}
            className="btn-primary"
            data-consent-open
          >
            Update my cookie preferences
          </button>
        </div>
      </Reveal>

      <Reveal delay={180}>
        <div className="mt-10 text-sm text-ink-500 leading-relaxed">
          <p>
            This policy is a placeholder draft. Final wording is being
            reviewed by counsel before go-live. If you have questions about
            how Sanctology Welfare Foundation handles your data, write to{" "}
            <a
              href="mailto:hope@sanctology.com"
              className="text-royal hover:text-royal-hi underline"
            >
              hope@sanctology.com
            </a>
            .
          </p>
        </div>
      </Reveal>
    </section>
  );
}
